import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';

@Injectable()
export class CheckOrderGuard implements CanActivate {
	constructor(
		public repository: RepositoryService,
		private router: Router
	) {}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
		// Redirect via a UrlTree instead of triggering a second navigation inside the guard.
		// Starting `navService.home()` while this navigation is still being evaluated cancels the
		// in-flight navigation and leaves its `navigateByUrl` promise unsettled, which makes the
		// caller's loading spinner hang forever. Returning a UrlTree lets Angular resolve the
		// navigation cleanly.
		if (!this.repository._order) {
			return this.router.parseUrl('home');
		}
		return true;
	}
}
